export const COLORS = [
  '#06b6d4',
  '#ef4444',
  '#fee2e2',
  '#6366f1',
  '#5eead4',
  '#f3e8ff',
  '#8b5cf6',
  '#ffedd5',
  '#67e8f9',
  '#fae8ff',
  '#3b82f6',
  '#ec4899',
  '#fef3c7',
  '#f97316',
  '#dbeafe',
  '#10b981',
  '#ecfccb',
  '#a5b4fc',
  '#ffe4e6',
  '#0ea5e9',
  '#d1fae5',
  '#f0abfc',
  '#f43f5e',
  '#fef9c3',
  '#fce7f3',
  '#84cc16',
  '#93c5fd',
  '#d8b4fe',
  '#22c55e',
  '#f59e0b',
  '#dcfce7',
  '#eab308',
  '#fde047',
  '#a855f7',
  '#ffe4e6',
  '#7dd3fc',
  '#bef264',
  '#86efac',
  '#e0e7ff',
  '#f9a8d4',
  '#fcd34d',
  '#e0f2fe',
  '#fda4af',
  '#14b8a6',
  '#fdba74',
  '#cffafe',
  '#c4b5fd',
  '#fca5a5',
  '#6ee7b7',
  '#ccfbf1',
  '#ede9fe',
  '#d946ef',
  '#0284c7',
];
